import { useInputState } from './useInputState';
import { validateNameFormat, validateNameLength } from '../name';

const validations = [
  {
    validate: (value) => value && value.trim && !!value.trim(),
    errorMessage: 'nameRequiredError'
  },
  {
    validate: (value) => validateNameFormat(value),
    errorMessage: 'invalidName'
  },
  {
    validate: (value) => validateNameLength(value),
    errorMessage: 'invalidNameLength'
  }
];

export function useNameInputState(options) {
  return useInputState({
    initialValue: '',
    validations,
    ...(options || {})
  });
}
